export default __webpack_public_path__ + "static/media/picture-2.4a42eb77.png";